import React, { useState } from "react";
import { Form, DatePicker } from "antd";
import dayjs from "dayjs";
import {
  calculateEndDate,
  validateInsuranceStartDate,
} from "utils/insurance-validators";

export default function InsurancePeriodSection() {
  const [endDate, setEndDate] = useState(null);

  const disabledDate = (current) => {
    if (!current) return false;
    const today = dayjs().startOf("day");
    const earliestValid = today.add(3, "day");
    const latestValid = today.add(90, "day");
    return current.isBefore(earliestValid, "day") || current.isAfter(latestValid, "day");
  };

  const handleStartDateChange = (date) => {
    if (date) {
      const calculated = calculateEndDate(date);
      setEndDate(calculated);
    } else {
      setEndDate(null);
    }
  };

  return (
    <div>
      <h3>ระยะเวลาเอาประกันภัย (Insurance Period)</h3>

      <Form.Item
        label="วันเริ่มต้น (Start Date)"
        name="insuranceStartDate"
        rules={[
          {
            required: true,
            message: "กรุณาเลือกวันเริ่มต้นประกันภัย",
          },
          {
            validator: (_, value) => {
              if (!value) return Promise.resolve();
              if (validateInsuranceStartDate(value)) {
                return Promise.resolve();
              }
              return Promise.reject(
                new Error("กรุณาเลือกวันที่ในอนาคต (อย่างน้อย 3 วันจากวันนี้ และไม่เกิน 90 วัน)")
              );
            },
          },
        ]}
      >
        <DatePicker
          format="DD/MM/YYYY"
          disabledDate={disabledDate}
          onChange={handleStartDateChange}
          style={{ width: "100%" }}
          placeholder="เลือกวันเริ่มต้น"
        />
      </Form.Item>

      <Form.Item label="วันสิ้นสุด (End Date)">
        <DatePicker
          value={endDate}
          format="DD/MM/YYYY HH:mm"
          disabled
          style={{ width: "100%" }}
          placeholder="คำนวณอัตโนมัติ (1 ปี เวลา 12:00 น.)"
        />
      </Form.Item>

      {endDate && (
        <div style={{ color: "#666", fontSize: 13 }}>
          วันสิ้นสุดความคุ้มครอง: {endDate.format("DD/MM/YYYY")} เวลา 12:00 น.
        </div>
      )}
    </div>
  );
}
